/* eslint-disable */
import {calculateActualSize, convertMMtoPx, convertPxToCm, pickMeasurementChar} from "../services/helpers";
import FontsMapper from "../services/FontsMapper";

const fontsMapper = new FontsMapper();

const removeMarginRightFromSingleLetters = (html) => {
    return html.replace(/margin-right\s*:\s*[^;"]+;?/gi, '');
}
const getMeasurementCharForData = (data) => {
    const sizeConf = data.selectedFontObject?.fonts_conf?.find(
        (f) => f.font_size?.slug === data.selectedFontSizeObject?.slug
    );
    return pickMeasurementChar({
        allowedBigLetters: sizeConf?.allowed_big_letters,
        allowedSmallLetters: sizeConf?.allowed_small_letters,
        allowedNumbers: sizeConf?.allowed_numbers,
        allowedSpecial: sizeConf?.allowed_special,
    });
}
const actualFontSize = (section, fontsMapper, data, scaling = 0.75) => {
    return calculateActualSize(
        section.fontSizeValuePx,
        scaling,
        fontsMapper.fonts[data.selectedFontObject.woocommerce_product_id].clr[data.selectedFontSizeObject.slug].name,
        getMeasurementCharForData(data)
    )
}
const PdfForCutting = ({pdfItemsToRender, data, letterSpacing}) => {
    return (
        <html lang="pl-PL">
        <body style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '10px',
        }}>
        {pdfItemsToRender.map((section, index) => (
            <div
                style={{
                    padding: '2px',
                    border: '1px solid #000',
                    display: 'inline-block',
                    paddingLeft: '12px'
                }}
                key={index}
                dangerouslySetInnerHTML={{
                    __html:
                        `<style>
                            p.single-letter, span {
                                margin-right : 0!important;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                letter-spacing: ${letterSpacing - convertPxToCm(16)}cm;
                                font-size: ${actualFontSize(section, fontsMapper, data).actualSize}px;
                                text-align: ${section.textAlign};
                                font-family: ${fontsMapper.fonts[data.selectedFontObject.woocommerce_product_id].clr[data.selectedFontSizeObject.slug].name};
                            }
                        </style>
                        <div style="display: flex;  flex-direction: row; flex-wrap: wrap; align-items: center">
                            ${section.value}
                        </div>`
                }}
            />
        ))}
        </body>
        </html>
    );
}
export default PdfForCutting;
